<div class="card">
  <div class="body">
    <h4 class="lead" style="background-color: rgb(119, 89, 249);color: white;padding: 1rem 2rem;font-weight: bold;">{{title}}</h4>
    <div class="form-auth-small m-t-20 " style="padding: 1rem 2rem;" [formGroup]="dataForm">
      <p>{{sub_title}}</p>
      <div class="form-group">
        <input type="password" formControlName="old_password" class="form-control round"
          placeholder="Old Password">
        @if (dataForm?.get('old_password')?.errors?.required) {
          <span class="error">Old Password should not
          empty</span>
        }
      </div>
      <div class="form-group">
        <input type="password" formControlName="password" class="form-control round" placeholder="Password">
        @if (dataForm?.get('password')?.errors?.matching) {
          <span class="error">Password Should be match</span>
        }
        @if (dataForm?.get('password')?.errors?.required) {
          <span class="error">Password should not empty</span>
        }
      </div>
      <div class="form-group">
        <input type="password" formControlName="confirm_password" class="form-control round" placeholder="Password">
        @if (dataForm?.get('confirm_password')?.errors?.matching) {
          <span class="error">Password Should be match</span>
        }
        @if (dataForm?.get('confirm_password')?.errors?.required) {
          <span class="error">Password should not empty</span>
        }
      </div>
      @if (error_info) {
        <span class="error">{{error_info}}</span>
      }
    </div>
<div class="d-flex justify-content-center">
    <button type="submit" noDoubleClick (click)="changePassword()" [disabled]="loading"
      class="btn btn-primary btn-round btn-block align-right mb-3" >
      @if (loading) {
        <i class="pi pi-spin pi-spinner"></i>
      }
      {{ loading ? 'Saving...' : 'Change Password'}}
    </button>
  </div>
    <!-- <div class="separator-linethrough"><span>OR</span></div> -->
  </div>
</div>